<style src="../node_modules/buefy/dist/buefy.min.css"></style>

<style src="./css/main.min.css"></style>
<style src="./css/themeone.min.css"></style>
<!-- <style src="./css/themetwo.min.css"></style> -->
<style src="./css/responsive.min.css"></style>
<style>
/* @import url("https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.8.2/css/all.min.css"); */
</style>

<template>
  <div id="app">
    <div id="myContainer" ref="myContainerRef"></div>
    <router-view></router-view>
  </div>
</template>

<script>
import Vue from "vue";
import store from "./store";
import { getRouter } from "./router";
let router = getRouter({ store });
import axiosPlugin from "./plugins/axios";
import utilsPlugin from "./plugins/utils";
import io from "socket.io-client";

/* import the fontawesome core */
import { library } from "@fortawesome/fontawesome-svg-core";

/* import specific icons */
import {
  faHouse,
  faUser,
  faCartShopping,
  faClose,
  faCircleCheck,
  faWallet,
  faCircleXmark,
  faGear,
  faCoins,
  faBell,
  faRightFromBracket,
  faShuffle,
  faPencil,
  faTrash,
  faSearch,
  faEye,
  faAngleLeft,
  faAngleRight,
  faEyeSlash,
  faCopy,
  faPlus,
  faTimes,
  faAngleDown,
  faMinus,
  faCamera,
  faSmile,
  faPlane,
  faHome,
  faStar,
  faBolt,
} from "@fortawesome/free-solid-svg-icons";

import { faEnvelope } from "@fortawesome/free-regular-svg-icons";

import { faFacebookF, faGoogle } from "@fortawesome/free-brands-svg-icons";

/* import font awesome icon component */
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

library.add(
  faHouse,
  faUser,
  faCartShopping,
  faGear,
  faWallet,
  faCoins,
  faBell,
  faRightFromBracket,
  faShuffle,
  faPencil,
  faClose,
  faCircleCheck,
  faCircleXmark,
  faTrash,
  faSearch,
  faEye,
  faAngleLeft,
  faAngleRight,
  faAngleDown,
  faEyeSlash,
  faCopy,
  faPlus,
  faMinus,
  faEnvelope,
  faFacebookF,
  faTimes,
  faGoogle,
  faCamera,
  faSmile,
  faPlane,
  faHome,
  faStar,
  faEye,
  faBolt
);

/* add font awesome icon component */
Vue.component("font-awesome-icon", FontAwesomeIcon);

import Buefy, { ConfigProgrammatic } from "../buefy";
import {
  Table,
  Input,
  Modal,
  Button,
  Autocomplete,
  Field,
  Dialog,
  Snackbar,
  Tabs,
  Datepicker,
} from "../buefy";

Vue.use(Buefy, {
  defaultIconComponent: "font-awesome-icon",
  defaultIconPack: "fas",
});

ConfigProgrammatic.setOptions({
  defaultIconPack: "fas",
  defaultIconComponent: "font-awesome-icon",
});

import { i18n } from "./i18n";

Vue.use(axiosPlugin, { router, store, i18n });
Vue.use(utilsPlugin, { router, store, i18n });

Vue.use(Table);
Vue.use(Input);
Vue.use(Button);
Vue.use(Autocomplete);
Vue.use(Field);
Vue.use(Dialog);
Vue.use(Snackbar);
Vue.use(Tabs);

Vue.use(Modal);
Vue.use(Datepicker);
Vue.prototype.strLottoId = "";

import { mapGetters } from "vuex";

import "./vee-validate";
export default {
  name: "app",

  props: {
    cid: {
      type: String,
      default: "DM",
    },

    bid: {
      type: String,
      default: "DM",
    },
    mode: {
      type: String,
      default: "",
    },
    lang: {
      type: String,
      default: "en",
    },
  },
  i18n,
  router,
  store,
  computed: {
    ...mapGetters([
      "blnIsUserLoggedIn",
      "strToken",
      "arrLottoConfigs",
      "objWalletStats",
      "objUser",
      "objUserProfile",
    ]),
  },
  created() {
    this.$i18n.locale = this.lang;

    this.setLottos();
  },
  beforeDestroy() {},
  async mounted() {
    // router.push("/home");

    Vue.prototype.$strClientId = this.cid;
    Vue.prototype.$strBrandingId = this.bid;

    Vue.prototype.$strMode = this.mode;

    let strLoginToken = localStorage.getItem("t");

    strLoginToken =
      "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJvYmoiOnsiaWQiOjIxMywicGxheWVyX2lkIjoiYmI1YjMxODctOGFiMy01YmVjLTk4ZDUtM2RmZWU1NWU5NWNmIn0sImlhdCI6MTc0MDM5NzE0NSwiZXhwIjoxNzgzNTk3MTQ1fQ.T3YQ6l07gEYkJgwcV3CEvSaLY_sakLYg7O4j61mIRAM";
    //danny's token
    strLoginToken =
      "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJvYmoiOnsiaWQiOjM0NTEyMCwicGxheWVyX2lkIjoiYjBiOGY0NDQtMmE5ZS00YjFkLWE5MzItMGU3YzliMmExMGEyIn0sImlhdCI6MTc0MDM5Nzk3NCwiZXhwIjoxNzgzNTk3OTc0fQ.54yBqa1WbV84PjT9r0FXqN8V2kLs8f2JiLjSieMHFPY";

    if (strLoginToken) {
      this.setAxiosToken(strLoginToken);
      this.ping();
    }
    Vue.prototype.$root = this.$root;
    this.$store.commit("emitState");

    await this.load();
  },
  methods: {
    async loadWalletStats() {},
    async loadUserInfo() {
      let p1 = this.$myAxios.get("/u/wallet-stats");
      let p2 = this.$myAxios.get("/u/me");
      let arr = await Promise.all([p1, p2]);

      //console.log(arr);

      let objResponse1 = arr[0];
      let objResponse2 = arr[1];

      if (objResponse1.blnOK) {
        let objWalletStats = objResponse1.obj;
        //console.log("Setting wallet stats");

        this.$store.commit("setWalletStats", objWalletStats);
      } else {
        //console.log(objResponse1.strMessage);
      }

      if (objResponse2.blnOK) {
        let objUser = objResponse2.obj;
        //console.log("Setting user profile");
        this.$store.commit("setUserProfile", objUser);
      } else {
        //console.log(objResponse2.strMessage);
      }
    },
    async emitUserInfo() {
      let strLoginToken = localStorage.getItem("t");
      if (!strLoginToken) {
        console.log("user not logged in");
        return;
      }

      try {
        await this.loadUserInfo();
      } catch (e) {
        console.log(e);
      }

      let strBalance = "";
      let strPendingWithdrwal = "";
      let strMobile = "";
      let strAvatarUrl = "";

      if (this.objUserProfile) {
        strMobile = this.objUserProfile.mobile;
        strAvatarUrl = this.$utils.getAvatarFileName(this.objUserProfile);
      }

      if (this.objWalletStats) {
        strBalance = this.objWalletStats.fltEffectiveBalance;
      }

      let objUserInfo = {
        strBalance,
        strMobile,
        strPendingWithdrwal,
        strAvatarUrl,
      };

      //console.log(objUserInfo);

      this.$utils.emitWCEvent2(this, "userInfo", objUserInfo);
    },

    async load() {
      this.$store.commit("signIn", {
        objUser: { first_name: "test", last_name: "lastname" },
        strToken: "",
      });

      this.emitUserInfo();
      let arr = [this.loadLottosConfigs(), this.loadSettings()];
      let arrResponses = await Promise.all(arr);

      let objConfigResponse = arrResponses[0];
      let objSettingsResponse = arrResponses[1];

      if (objConfigResponse.blnOK) {
        let arr = objConfigResponse.arr;
        for (let obj of arr) {
          obj.strCountdown = "xx";
        }

        arr = this.sortLottos(arr);

        this.$store.commit("setLottoConfigs", arr);
      }

      if (objSettingsResponse.blnOK) {
        let { obj } = objSettingsResponse;
        this.$store.commit("setBrandingSettings", obj);
      }
    },
    sortLottos(arrLottos) {
      let arrSortedLottos = [];
      let arrLottoIds = ["five35"];
      for (let strLottoId of arrLottoIds) {
        let objLotto = arrLottos.find((obj) => obj.strLottoId == strLottoId);
        if (objLotto) {
          arrSortedLottos.push(objLotto);
        }
      }

      return arrSortedLottos;
    },
    setLottos() {
      this.$store.commit("setLottos", [
        {
          strId: "six49",
          strName: "Supa Lotto",
          strLogoName: "five35-lotto.jpg",
          arrStakes: [10],
          intDefaultStakeAmount: 10,
          strWinText:
            "<b>Win K25 Million Jackpot! Pick 6 numbers. 2 draws weekly.</b>",
        },
      ]);
    },

    async loadLottosConfigs() {
      let objRequest = {
        arrLottoIds: ["wkly"],
      };
      return this.$myAxios.post("/lottos-configs", objRequest);
    },

    async loadSettings() {
      return this.$myAxios.get("/lb-settings");
    },

    async ping() {
      try {
        let objResponse = await this.$myAxios.get("/u/ping");
        if (!objResponse.blnOK) {
          this.$store.commit("logout");
          this.$utils.emitWCEvent(this, "signIn");
        }
      } catch (e) {
        console.log(e);
      }
    },
  },
};
</script>
